/// <reference path="../types/index.d.ts" />

import '../client_forms/tcavenueevent/style.css';
import FormStructure from './tcavenueevent/form_structure';

export default FormStructure;